var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorWarningLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error-warning-line_svg__clip0_1074_24657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 29.334c-7.365 0-13.334-5.97-13.334-13.334S8.636 2.667 15.999 2.667c7.364 0 13.334 5.97 13.334 13.333 0 7.364-5.97 13.334-13.334 13.334zm0-2.667a10.667 10.667 0 100-21.333 10.667 10.667 0 000 21.333zM14.665 20h2.667v2.667h-2.667V20zm0-10.666h2.667v8h-2.667v-8z",
    fill: "#D4D4D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "error-warning-line_svg__clip0_1074_24657"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
export default SvgErrorWarningLine;